import { useDispatch, useSelector } from 'react-redux';
import { selectEligibleOffers, selectUnlockedOffers, setOffers } from '../../../../store/slices/OfferSlice';
import useGetBasketOfferHandlerByKind from '../get-offer-handler/useGetBasketOfferHandlerByKind';
import { Offer } from '../../../../services/exports/Interfaces';
import { useEffect } from 'react';
import { CompleteBasketItem } from '../../../../providers/BasketProvider';
import useGetCompanyMenusApi from '../../../../hooks/api/companies/useGetCompanyMenusApi';

const useWatchEligibleOffers = (items: CompleteBasketItem[]) => {
  const eligibleOffers = useSelector(selectEligibleOffers);
  const unlockedOffers = useSelector(selectUnlockedOffers);
  const dispatch = useDispatch();
  const { data } = useGetCompanyMenusApi();
  const offerHandler = useGetBasketOfferHandlerByKind();
  const setEligibleOffers = (offers: Offer[] = []) => {
    if (!offers.length && !eligibleOffers.length) {
      return;
    }

    dispatch(setOffers({ eligibleOffers: offers }));
  };
  const unlockedOffersHandler = (): void => {
    const result = unlockedOffers.filter((offer) => offerHandler(offer, items).isEligible);

    setEligibleOffers(result);
  };

  useEffect(() => {
    if (!data) {
      return;
    }

    unlockedOffersHandler();
  }, [unlockedOffers, items, data]);
};

export default useWatchEligibleOffers;
